module.exports = __webpack_public_path__ + "img/04.85bd530c.png";